var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/pdf-broken") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "9.16666667e-05 0.000366666667 18.3333333 0.000366666667 18.3333333 13.676919 9.16666667e-05 13.676919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.000275 0.333391667 18.3333333 0.333391667 18.3333333 9.16666667 0.000275 9.16666667"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/pdf-broken",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(3.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.208425,5.50036667 L17.783425,5.50036667 C17.8760083,5.50036667 17.959425,5.44353333 17.995175,5.3592 C18.030925,5.27303333 18.0107583,5.17495 17.945675,5.10803333 L13.2248417,0.38995 C13.1588417,0.324866667 13.061675,0.3047 12.9755083,0.339533333 C12.8902583,0.374366667 12.833425,0.457783333 12.833425,0.550366667 L12.833425,4.12536667 C12.833425,4.88436667 13.4485083,5.50036667 14.208425,5.50036667",
    id: "Fill-1",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1042583,6.41703333 L18.102425,6.41703333 L14.208425,6.41703333 C13.5695083,6.41703333 12.992925,6.15486667 12.577675,5.7332 C12.1697583,5.31978333 11.9167583,4.75236667 11.9167583,4.12536667 L11.9167583,0.2277 C11.9167583,0.1012 11.8150083,0.000366666667 11.689425,0.000366666667 L1.833425,0.000366666667 C0.821425,0.000366666667 9.16666667e-05,0.8217 9.16666667e-05,1.8337 L9.16666667e-05,6.37486667 L9.16666667e-05,11.5192 L2.361425,13.5652 C2.53284167,13.7137 2.78859167,13.7137 2.960925,13.5652 L6.60834167,10.41645 C6.77975833,10.26795 7.03550833,10.26795 7.206925,10.41645 L10.8543417,13.5652 C11.026675,13.7146167 11.282425,13.7137 11.4547583,13.5652 L15.1012583,11.3248667 C15.2735917,11.17545 15.5293417,11.17545 15.701675,11.3248667 L18.333425,13.6046167 L18.333425,6.7177 L18.333425,6.64436667 C18.3325083,6.51786667 18.2298417,6.41703333 18.1042583,6.41703333",
    id: "Fill-3",
    fill: "#666666",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 12.833333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8554417,3.59535 L7.20710833,0.444766667 C7.03569167,0.296266667 6.77994167,0.296266667 6.608525,0.444766667 L2.96019167,3.59535 C2.78785833,3.74385 2.533025,3.74385 2.36069167,3.59626667 L0.000275,1.56401667 L0.000275,7.33351667 C0.000275,8.34643333 0.820691667,9.16685 1.83360833,9.16685 L16.500275,9.16685 C17.512275,9.16685 18.3336083,8.34643333 18.3336083,7.33351667 L18.3336083,2.73643333 L15.7009417,0.45485 C15.5286083,0.30635 15.273775,0.30635 15.1014417,0.453933333 L11.454025,3.59535 C11.2816917,3.74385 11.0268583,3.74385 10.8554417,3.59535",
    id: "Fill-6",
    fill: "#666666",
    mask: "url(#mask-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBroken);
export default __webpack_public_path__ + "static/media/pdfBroken.a23129659df0b3630900ac79f5a130a4.svg";
export { ForwardRef as ReactComponent };